"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var variables_1 = require("../variables");
/**
 * The purpose of the default theme is to store properties that are shared in both
 * light and dark theme. Ligt and dark theme will merge themselves into the default theme.
 */


exports.defaultTheme = {
  global: {
    accentColor: variables_1.colors.cobayellow,
    successColor: variables_1.colors.green
  },
  button: {
    primary: {
      textColor: variables_1.colors.anthrazit,
      hover: {
        backgroundColor: variables_1.colors.vividOrange,
        textColor: variables_1.colors.black
      },
      active: {
        backgroundColor: variables_1.colors.darkOrange,
        textColor: variables_1.colors.black
      }
    }
  },
  mainStage: {
    scrollDownColor: variables_1.colors.white
  },
  circle: {
    borderColor: variables_1.colors.black,
    link: {
      borderColor: variables_1.colors.anthrazit,
      hover: {
        borderColor: variables_1.colors.black
      }
    }
  },
  footer: {
    branding: {
      backgroundColor: variables_1.colors.anthrazit
    },
    meta: {
      borderColor: variables_1.colors.lightAnthracite
    },
    link: {
      textColor: variables_1.colors.white,
      hover: {
        textColor: variables_1.colors.grey
      }
    }
  }
};